import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { UserInfo } from '@modules/users/models/user';
import {
  BehaviorSubject,
  Observable,
  ReplaySubject,
  Subject,
  catchError,
  map,
  of,
  throwError,
} from 'rxjs';
import { User } from 'src/app/data/users/models/user.model';
import { ApiClient } from 'src/app/lib/api/api-client';
import { ModerationAreas, ModeratorRole } from 'src/app/lib/api/user/api.user.model';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  basePath = environment.baseURL;
  private isLoginSubject = new BehaviorSubject<boolean | null>(null);
  private _userInfo: ReplaySubject<UserInfo | null> = new ReplaySubject();
  private userInfo$: Observable<UserInfo | null> =
    this._userInfo.asObservable();
  private userProfile = new ReplaySubject<UserInfo | null>();
  private api: ApiClient

  constructor(private http: HttpClient) {
    this.api = new ApiClient(this.http, { responseTimeout: environment.API_TIMEOUT });
  }

  getUserProfile() {
    return this.userProfile.asObservable();
  }

  setUserProfile(data: UserInfo | null) {
    this.userProfile.next(data);
  }

  getUserInfo(id: string) {
    //TODO: Replace with actual code
    // return this.http.get(`${this.basePath}/auth/user-info/` + id);
    return of(['admin']);
  }

  getModuleRole() {
    return this.http.get<any>(`${environment.baseURL}/user/admin/roles/module`);
  }

  getUserInfoById(userId: string): Observable<UserInfo> {
    return this.http
      .get<UserInfo>(this.basePath + `/user/users/${userId}`)
      .pipe(
        map((res: any) => {
          return res.data;
        }),
        catchError(this.handleError)
      );
  }

  saveUserInfoToLocalStorage(userRole: string[]) {
    localStorage.setItem(environment.USER_ROLE_KEY, JSON.stringify(userRole));
  }

  getUserInfoFromLocalStorage() {
    const userInfoString = localStorage.getItem(environment.USER_ROLE_KEY);
    if (userInfoString) return JSON.parse(userInfoString);
  }

  clearUserLocalStorage() {
    localStorage.removeItem(environment.USER_ROLE_KEY);
  }

  setUserInfo(userInfo: UserInfo | null) {
    this._userInfo.next(userInfo);
  }

  getUserInfor() {
    return this.userInfo$;
  }

  setLoginStatus(isLogin: boolean): void {
    this.isLoginSubject.next(isLogin);
  }

  getLoginStatus(): Observable<boolean | null> {
    return this.isLoginSubject.asObservable();
  }
  setLoginStatusToLocalStorage(isLogin: boolean): void {
    localStorage.setItem(
      environment.AUTH_STATUS,
      JSON.stringify({ isLoggedIn: isLogin })
    );
  }

  getLoginStatusFromLocalStorage() {
    const userInfoString = localStorage.getItem(environment.AUTH_STATUS);
    if (userInfoString) return JSON.parse(userInfoString);
  }
  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => {
      return errorMessage;
    });
  }

  getUserUuid() {
    const user = JSON.parse(
      localStorage.getItem(environment.USER_PROFILE) || '{}'
    );
    //IF: Logged in => Use userId
    //ELSE: use uuid
    return user.id ? user.id : localStorage.getItem(environment.USER_UUID);
  }

  setUserUuid() {
    localStorage.setItem(environment.USER_UUID, uuidv4());
  }

  getModeratorRole(): Observable<ModeratorRole[]> {
      return this.api.user.getModeratorRole();
    }
  
    getModerationAreas(textSearch: string): Observable<ModerationAreas[]> {
      return this.api.user.getModerationAreas(textSearch);
    }
  
    getTokenToLoadIframe(): Observable<string> {
      return this.api.user.getTokenToLoadIframe();
    }
  
    getPermissionCodeList() {
      return this.api.user.getPermissionCodeList();
    }

     getPermissionCodeByModule(moduleType: any) {
      return this.api.user.getPermissionCodeByModule(moduleType);
    }

    getAllUserAdmin(pageSize: number,pageNum: number, textSearch: string): Observable<any> {
      return this.api.user.getAllUserAdmin(pageSize, pageNum, textSearch);
    }
}
